import { render, staticRenderFns } from "./RolesPanel.vue?vue&type=template&id=3e41d35f"
import script from "./RolesPanel.vue?vue&type=script&lang=js"
export * from "./RolesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports